<script>
	import {user, game, send_data} from '../client.svelte.js'

	let taleID = $derived(game.tale?.replace("#", "") ?? "")
	let tale = $derived(user.tales.get(taleID))
	let sessions = $derived(
		user.sessions.values()
			.filter(sess => sess.TALE === taleID)
			.toArray()
			.toSorted((a, b) => Number(a.STEP) - Number(b.STEP)))
	// only one session per day can be created (date of today in local time as YYYY-MM-DD)
	const now = new Date()
	const today = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`
	let creatable = $derived(!game.demo && !sessions.some(sess => sess.started?.startsWith(today)))

	function create_session() {
		console.log(`NOTESPANEL: Create new session in tale ${taleID}`)
		send_data('/session', {}, 'POST')
	}

	/** players with the heroes they played, e.g. "Florian (Xarim), Martin (Zandor)" **/
	function players_of(session) {
		return Object.entries(session.players ?? {})
			.map(([player, heroIDs]) => `${player} (${heroIDs.map(heroID => user.characters.get(heroID)?.name ?? heroID).join(", ")})`)
			.join(", ")
	}

	function change_tale_notes(e) {
		console.log(`NOTESPANEL: Change notes in tale ${taleID} to: `,  e.target.value)
		send_data(`/tale/${taleID}`, {notes: e.target.value}, 'PATCH')
	}

	function change_session_notes(sessionID, e) {
		console.log(`NOTESPANEL: Change notes in session ${sessionID} to: `,  e.target.value)
		send_data(`/session/${sessionID}`, {notes: e.target.value}, 'PATCH')
	}

</script>


<!-------------------------------- HTML -------------------------------------->

<div id=NotesPanel>
	<section class=taleNotes>
		<label for=taleNotes>Notizen des Meisters zum Abenteuer:</label>
		<textarea id=taleNotes value={tale?.notes ?? ""} onchange={change_tale_notes} ></textarea>
	</section>

	{#each sessions as session (session.ID)}
		<section class=sessionNotes>
			<label for="notes-{session.ID}">
				<span class=title>{session.STEP}. Spielabend</span>
				<span class=date>{(session.started) ? new Date(session.started).toLocaleDateString('de-DE') : ""}</span>
				<span class=times>({session.duration} h)</span>
				<span class=players>{players_of(session)}</span>
			</label>
			<textarea id="notes-{session.ID}" value={session.notes ?? ""} onchange={change_session_notes.bind(null, session.ID)} ></textarea>
		</section>
	{/each}

	{#if creatable}
		<button class="button-secondary createBtn" onclick={create_session}>Session anlegen</button>
	{/if}
</div>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	#NotesPanel
		height: calc(100vh - 100px)
		overflow-y: auto

	section
		margin: 0 1em 1em 0

	label
		display: block
		font-weight: bold

	textarea
		margin: 0.5em 0 0 1em
		width: 92%
		resize: vertical

	.taleNotes
		padding-bottom: 1em
		border-bottom: 3px double darkgrey

		textarea
			height: 40vh

	.sessionNotes
		label span + span::before
			content: " – "
			font-weight: normal

		.date, .times, .players
			font-weight: normal

		textarea
			height: 20vh

	.createBtn
		margin-left: 1em

</style>
